import { ReactNode, useState } from "react";
import Loading from "../common/loading/loading";
import "./image.sass";

type Props = {
  src: string;
  alt: string;
  className?: string;
  errorFallback?: ReactNode;
};

const SPINNER_SIZE = 48;

const Image = ({ src, alt, className, errorFallback }: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  if (isError) {
    return (
      <div className={className}>
        {errorFallback ?? (
          <span style={{ color: "#000" }}>Ошибка загрузки изображения</span>
        )}
      </div>
    );
  }

  return (
    <div className="image">
      {isLoading && (
        <div className="image__spinner">
          <Loading
            isLoading={true}
            width={SPINNER_SIZE}
            height={SPINNER_SIZE}
          />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => {
          setIsLoading(false);
        }}
        onError={() => {
          setIsLoading(false);
          setIsError(true);
        }}
        style={isLoading ? { opacity: 0 } : undefined}
      />
    </div>
  );
};

export default Image;
